export default __webpack_public_path__ + "static/media/img-step-b-bg-2@3x.d3c19e94.jpg";